<template>
	<div
		v-editable="blok"
		:style="{ height: heightValue }"
		class="w-full flex items-center"
	>
		<div v-if="blok.isLine" class="w-full border-t border-gray-dark"></div>
	</div>
</template>

<script setup lang="ts">
import type { BlokSeparator } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokSeparator;
}

const { blok } = defineProps<Props>();

const heightValue = computed(() => {
	const numeric = Number(blok.height);

	if (!Number.isNaN(numeric)) {
		return `${numeric}px`;
	}

	return blok.height.trim() || "1rem";
});
</script>
